/* eslint-disable max-classes-per-file */

/**
 * One Param Element
 */
export class ParamElement {
    /**
     * @param {object} data data
     * @param {(string | number)=} data.key key
     * @param {string=} data.text text
     * @param {string=} data.codeCompany codeCompany
     * @param {string=} data.codeCentre codeCentre
     */
    constructor({
        key = 0, text = '', codeCompany = '', codeCentre = '',
    } = {}) {
        this.key = key
        this.text = text
        this.codeCompany = codeCompany
        this.codeCentre = codeCentre
    }
}

/**
 * All param
 */
export default class Param {
    /**
     * @param {object} data data
     */
    constructor(data = []) {
        /** @type {ParamElement[]} Profiles */
        this.profiles = []

        /** @type {ParamElement[]} companies */
        this.companies = []

        /** @type {ParamElement[]} analyticalCenters */
        this.analyticalCenters = []

        /** @type {ParamElement[]} Managers */
        this.managers = []

        /** @type {ParamElement[]} Managers */
        this.exportStatuses = []

        // eslint-disable-next-line
        for (const param in data)
            this[param] = data[param]?.map(x => new ParamElement(x)) ?? []
    }
}
